import { render, staticRenderFns } from "./MarketingManage.vue?vue&type=template&id=e8a4beda"
import script from "./MarketingManage.vue?vue&type=script&lang=ts"
export * from "./MarketingManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports